// extracted by mini-css-extract-plugin
export default {"wrapper":"HappyBunch_wrapper__acJc+","imgWrapper":"HappyBunch_imgWrapper__hrth1"};